/* --------------------------------------------------------------------------------------
   dynamicGlyph.component.js

   Copyright © 2019 Xerox Corporation. All Rights Reserved.
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const dynamicGlyphComponent = {
  template: '<span class="xrx-glyphicon" ng-class="vm.iconClass"></span>',
  bindings: {
    type: '<'
  },
  controllerAs: 'vm',
  controller: class dynamicGlyphCtrl {
    $onChanges() {
      this.iconClass = this.getIconByType(this.type)
    }
    getIconByType(type) {
      const icon = this.getIcons().find(icon => icon.type == type)
      return icon? icon.cssClass : 'glyphicon-file'
    }
    getIcons() {
      return  [
        {type: 'root', cssClass: 'glyphicon-group'},
        {type: 'client', cssClass: 'glyphicon-user'},
        {type: 'matter', cssClass: 'glyphicon-folder'},
        {type: 'Folder', cssClass: 'glyphicon-folder'},
        {type: 'Document', cssClass: 'glyphicon-file'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/browser/components/dynamicGlyph.component.js